import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import SchoolLookUpLayout from './SchoolLookUpLayout'

const SchoolLookUp = props => {
  const { disabled, fireOnLoad, siteData, onSelection } = props

  const [selectedSiteData, setSelectedSiteData] = useState({
    city: '',
    companyName: '',
    country: '',
    netsuiteCustomerId: null,
    nsCustomerId: '',
    organizationName: '',
    region: '',
  })
  const [hasRegionData, setHasRegionData] = useState(true)

  useEffect(() => {
    if (siteData && fireOnLoad) {
      onSelection({
        city: siteData.city,
        companyName: siteData.companyName,
        country: siteData.country,
        netsuiteCustomerId: siteData.netSuiteCustomerId || null,
        nsCustomerId: siteData.nsCustomerId,
        organizationName: siteData.organizationName || '',
        region: siteData.region,
      })
    }
  }, [])

  useEffect(() => {
    if (siteData) {
      setSelectedSiteData({
        city: siteData.city,
        companyName: siteData.companyName,
        country: siteData.country,
        netsuiteCustomerId: siteData.netsuiteCustomerId || null,
        nsCustomerId: siteData.nsCustomerId,
        organizationName: siteData.organizationName || '',
        region: siteData.region,
      })
    }
  }, [siteData])

  const handlers = {
    handleChange: event => {
      const name = event.target.name
      const value = event.target.value
      const newState = { [name]: value }

      if (name === 'city') {
        newState.country = selectedSiteData.country
        newState.nsCustomerId = ''
        newState.organizationName = ''
        newState.region = selectedSiteData.region
      }
      if (name === 'region') {
        newState.city = ''
        newState.country = selectedSiteData.country
        newState.nsCustomerId = ''
        newState.organizationName = ''
      }
      if (name === 'country') {
        newState.city = ''
        newState.nsCustomerId = ''
        newState.organizationName = ''
        newState.region = ''
      }

      setSelectedSiteData(newState)
      onSelection(newState)
    },

    handleLoadStateData: data => {
      setHasRegionData(data.length > 1)
      return data
    },

    handleSchoolSelect: netSuiteCustomer => {
      const { netsuiteCustomerId, nsCustomerId, companyName } = netSuiteCustomer
      const isListed = netsuiteCustomerId !== 0

      const newSelection = {
        ...selectedSiteData,
        companyName: isListed ? companyName : '',
        netsuiteCustomerId,
        nsCustomerId,
      }

      setSelectedSiteData(newSelection)
      onSelection(newSelection)
    },

    handleSchoolNameChange: e => {
      const organizationName = e.target.value
      const nsCustomerId = selectedSiteData.nsCustomerId || ''
      const netsuiteCustomerId = selectedSiteData.netsuiteCustomerId || 0

      const newNameChange = {
        ...selectedSiteData,
        organizationName,
        netsuiteCustomerId,
        nsCustomerId,
      }
      setSelectedSiteData(newNameChange)
      onSelection(newNameChange)
    },

    selectCitiesEndpoint: () => {
      if (selectedSiteData.region) {
        return `location/cities?country=${selectedSiteData.country}&region=${selectedSiteData.region}`
      } else if (!hasRegionData && selectedSiteData.country) {
        return `location/cities?country=${selectedSiteData.country}`
      }
      return ''
    },

    selectSchoolsEndpoint: () => {
      if (selectedSiteData.city) {
        return !hasRegionData
          ? `/netsuitecustomers?country=${selectedSiteData.country}&city=${selectedSiteData.city}`
          : `/netsuitecustomers?country=${selectedSiteData.country}&region=${selectedSiteData.region}&city=${selectedSiteData.city}`
      }
      return ''
    },
  }

  return (
    <SchoolLookUpLayout
      {...selectedSiteData}
      {...handlers}
      disabled={disabled}
      hasRegionData={hasRegionData}
    />
  )
}

SchoolLookUp.propTypes = {
  disabled: PropTypes.bool,
  fireOnLoad: PropTypes.bool,
  onSelection: PropTypes.func.isRequired,
  siteData: PropTypes.object.isRequired,
}

SchoolLookUp.defaultProps = {
  fireOnLoad: true,
}

export default SchoolLookUp



// WEBPACK FOOTER //
// ./src/components/SchoolLookUp/SchoolLookUp.js